class $f68696a8a25b0664$export$2e2bcd8739ae039 {
    constructor({ maxBars: maxBars , visualizerContainerQuery: visualizerContainerQuery  }){
        this.bars = [];
        this.generateBars = ()=>{
            // TODO: stop any running sorts
            // this.stopSorts()
            if (this.visualizerContainerQuery.length > 0) {
                const visualizerContainer = this.visualizerContainerQuery[0];
                // Clear all of the bars that might be there from a previous run
                visualizerContainer.innerHTML = "";
                // Put the "Generate Bars" button on the DOM which randomly generates a set of bars
                this.bars = this.getRandomBarValues().map((barValue, index)=>{
                    const { heightPercentOfViewport: heightPercentOfViewport  } = barValue;
                    // Create the bar div element
                    const domElement = document.createElement("div");
                    domElement.className = "bar";
                    domElement.style.height = `${heightPercentOfViewport}%`;
                    domElement.style.order = `${index}`;
                    const bar = {
                        domElement: domElement,
                        ...barValue
                    };
                    return bar;
                });
                // Put bars on the DOM
                visualizerContainer?.append(...this.bars.map((bar)=>bar.domElement));
                return this.bars.length;
            }
            return null;
        };
        this.getRandomBarValues = ()=>{
            return Array.from({
                length: this.getRandomNumberBetween(1, this.maxBars)
            }, (_x, originalOrder)=>{
                const height = this.getRandomNumberBetween(1, this.maxBars);
                const heightPercentOfViewport = height / this.maxBars * 100;
                return {
                    height: height,
                    heightPercentOfViewport: heightPercentOfViewport,
                    originalOrder: originalOrder
                };
            });
        };
        this.getRandomNumberBetween = (min, max)=>{
            return Math.floor(Math.random() * (max - min) + min);
        };
        this.hasBars = ()=>{
            return this.bars.length > 0;
        };
        this.isSorted = ()=>{
            if (!this.hasBars()) {
                alert("No bars");
                return false;
            }
            let lastBar = this.bars[0];
            return this.bars.every((bar)=>{
                const nextBarTaller = bar.height >= lastBar.height;
                lastBar = bar;
                return nextBarTaller;
            });
        };
        this.resetBars = ()=>{
            // Only merge sort can be reset by changing style.order. 
            // All the other sorts actually change the order of the bar in place, 
            // so this needs to be undone.
            this.bars.sort((barA, barB)=>{
                return barA.originalOrder - barB.originalOrder;
            }).forEach((bar, index)=>{
                this.bars[index].domElement.style.order = `${bar.originalOrder}`;
                this.bars[index].domElement.classList.remove("sorted");
            });
        };
        this.setMaxBars = ({ maxBars: maxBars  })=>{
            this.maxBars = maxBars;
        };
        this.setSortDelay = ({ sortDelay: sortDelay  })=>{
            this.sortDelay = sortDelay;
        };
        this.sort = ({ algorithm: algorithm , callback: callback  })=>{
            const args = {
                bars: this.bars,
                startingIndex: 0,
                endingIndex: this.bars.length - 1,
                visualizer: this
            };
            algorithm(args).then(()=>{
                callback();
            }).catch((_error)=>{
                console.log("The running algorithm has encountered an error");
            });
        };
        this.maxBars = maxBars || 0;
        this.sortDelay = 1000;
        this.visualizerContainerQuery = visualizerContainerQuery;
    }
}


const $0750269de72ea89d$var$delay = ({ timeout: timeout  })=>{
    return new Promise((resolve)=>{
        setTimeout(()=>resolve(""), timeout);
    });
};
const $0750269de72ea89d$var$colorSelectBars = ({ bars: bars , indexes: indexes  })=>{
    indexes.forEach((index)=>bars[index].domElement.classList.add("selected"));
};
const $0750269de72ea89d$var$deColorSelectBars = ({ bars: bars , indexes: indexes  })=>{
    indexes.forEach((index)=>bars[index].domElement.classList.remove("selected"));
};
const $0750269de72ea89d$var$colorSortedBars = ({ bars: bars , indexes: indexes  })=>{
    indexes.forEach((index)=>bars[index].domElement.classList.add("sorted"));
};
const $0750269de72ea89d$var$deColorSortedBars = ({ bars: bars , indexes: indexes  })=>{
    indexes.forEach((index)=>bars[index].domElement.classList.remove("sorted"));
};
const $0750269de72ea89d$export$b898cba43580844e = async ({ bars: bars , visualizer: visualizer  })=>{
    const numberOfBars = bars.length;
    // The unsortedCount is the length of the part of the array that's not yet sorted
    let unsortedCount = numberOfBars - 1;
    // The unsortedCount just keeps track of which iteration we're on
    while(unsortedCount > 0){
        // The index is what's really in charge of the manipulation
        for(let index = 0; index < unsortedCount; index++){
            const nextIndex = index + 1;
            $0750269de72ea89d$var$colorSelectBars({
                bars: bars,
                indexes: [
                    index,
                    nextIndex
                ]
            });
            await $0750269de72ea89d$var$delay({
                timeout: visualizer.sortDelay
            });
            if (bars[index].height > bars[nextIndex].height) await $0750269de72ea89d$var$switchBars({
                bars: bars,
                i: index,
                j: nextIndex,
                visualizer: visualizer
            });
            $0750269de72ea89d$var$deColorSelectBars({
                bars: bars,
                indexes: [
                    index,
                    nextIndex
                ]
            });
        }
        if (bars[unsortedCount].height > bars[unsortedCount - 1].height) $0750269de72ea89d$var$colorSortedBars({
            bars: bars,
            indexes: [
                unsortedCount
            ]
        });
        else $0750269de72ea89d$var$colorSortedBars({
            bars: bars,
            indexes: [
                unsortedCount - 1
            ]
        });
        if (bars[unsortedCount].height == bars[unsortedCount - 1].height) $0750269de72ea89d$var$colorSortedBars({
            bars: bars,
            indexes: [
                unsortedCount
            ]
        });
        unsortedCount--;
    }
    $0750269de72ea89d$var$colorSortedBars({
        bars: bars,
        indexes: [
            0
        ]
    });
};
const $0750269de72ea89d$var$arrayRange = (start, stop, step = 1)=>Array.from({
        length: (stop - start) / step + 1
    }, (_value, index)=>start + index * step);
// TODO: see if we can clean this up at all
const $0750269de72ea89d$var$merge = async ({ bars: bars , startingIndex: startingIndex , pivot: pivot , endingIndex: endingIndex , visualizer: visualizer  })=>{
    const leftArraySize = pivot - startingIndex + 1;
    const rightArraySize = endingIndex - pivot;
    // Create temp arrays
    const leftArray = new Array(leftArraySize);
    const rightArray = new Array(rightArraySize);
    let leftArrayIndex = 0;
    let rightArrayIndex = 0;
    // Set the left and right arrays
    for(let currentIndex = startingIndex; currentIndex <= endingIndex; currentIndex++)if (currentIndex <= pivot) {
        leftArray[leftArrayIndex] = bars[currentIndex];
        leftArrayIndex++;
    } else {
        rightArray[rightArrayIndex] = bars[currentIndex];
        rightArrayIndex++;
    }
    leftArrayIndex = 0;
    rightArrayIndex = 0;
    // // Sort bars by left and right arrays
    $0750269de72ea89d$var$deColorSortedBars({
        bars: bars,
        indexes: $0750269de72ea89d$var$arrayRange(startingIndex, endingIndex)
    });
    for(let currentIndex = startingIndex; currentIndex <= endingIndex; currentIndex++){
        // Ensure that the indexes are in range
        if (leftArrayIndex < leftArraySize && rightArrayIndex < rightArraySize) {
            // If they are, assign the correct bar
            if (leftArray[leftArrayIndex].height < rightArray[rightArrayIndex].height) {
                bars[currentIndex] = leftArray[leftArrayIndex];
                leftArrayIndex++;
            } else {
                bars[currentIndex] = rightArray[rightArrayIndex];
                rightArrayIndex++;
            }
        } else if (leftArrayIndex < leftArraySize) {
            bars[currentIndex] = leftArray[leftArrayIndex];
            leftArrayIndex++;
        } else {
            bars[currentIndex] = rightArray[rightArrayIndex];
            rightArrayIndex++;
        }
        bars[currentIndex].domElement.style.order = `${currentIndex}`;
        await $0750269de72ea89d$var$delay({
            timeout: visualizer.sortDelay
        });
        $0750269de72ea89d$var$colorSortedBars({
            bars: bars,
            indexes: [
                currentIndex
            ]
        });
    }
};
const $0750269de72ea89d$export$9c006f0f3b83dc93 = async ({ bars: bars , startingIndex: startingIndex , endingIndex: endingIndex , visualizer: visualizer  })=>{
    // Base case. Nothing left to do here
    if (startingIndex == endingIndex) return;
    const pivot = Math.floor((startingIndex + endingIndex) / 2);
    await $0750269de72ea89d$export$9c006f0f3b83dc93({
        bars: bars,
        startingIndex: startingIndex,
        endingIndex: pivot,
        visualizer: visualizer
    });
    await $0750269de72ea89d$export$9c006f0f3b83dc93({
        bars: bars,
        startingIndex: pivot + 1,
        endingIndex: endingIndex,
        visualizer: visualizer
    });
    await $0750269de72ea89d$var$merge({
        bars: bars,
        startingIndex: startingIndex,
        pivot: pivot,
        endingIndex: endingIndex,
        visualizer: visualizer
    });
};
const $0750269de72ea89d$var$partition = async ({ bars: bars , startingIndex: startingIndex , endingIndex: endingIndex , visualizer: visualizer  })=>{
    const pivot = bars[endingIndex];
    let i = startingIndex - 1;
    for(let currentIndex = startingIndex; currentIndex <= endingIndex - 1; currentIndex++)if (bars[currentIndex].height < pivot.height) {
        i++;
        await $0750269de72ea89d$var$switchBars({
            bars: bars,
            i: i,
            j: currentIndex,
            visualizer: visualizer
        });
    }
    i++;
    await $0750269de72ea89d$var$switchBars({
        bars: bars,
        i: i,
        j: endingIndex,
        visualizer: visualizer
    });
    return i;
};
const $0750269de72ea89d$export$866270269b9544a5 = async ({ bars: bars , startingIndex: startingIndex , endingIndex: endingIndex , visualizer: visualizer  })=>{
    // Base case. Nothing left to do here
    if (endingIndex <= startingIndex) return;
    const pivot = await $0750269de72ea89d$var$partition({
        bars: bars,
        startingIndex: startingIndex,
        endingIndex: endingIndex,
        visualizer: visualizer
    });
    // pivot is always the sorted element
    $0750269de72ea89d$var$colorSortedBars({
        bars: bars,
        indexes: [
            pivot
        ]
    });
    const firstRange = $0750269de72ea89d$var$arrayRange(startingIndex, pivot - 1);
    $0750269de72ea89d$var$deColorSortedBars({
        bars: bars,
        indexes: firstRange
    });
    await $0750269de72ea89d$export$866270269b9544a5({
        bars: bars,
        startingIndex: startingIndex,
        endingIndex: pivot - 1,
        visualizer: visualizer
    });
    $0750269de72ea89d$var$colorSortedBars({
        bars: bars,
        indexes: firstRange
    });
    const secondRange = $0750269de72ea89d$var$arrayRange(pivot + 1, endingIndex);
    $0750269de72ea89d$var$deColorSortedBars({
        bars: bars,
        indexes: secondRange
    });
    await $0750269de72ea89d$export$866270269b9544a5({
        bars: bars,
        startingIndex: pivot + 1,
        endingIndex: endingIndex,
        visualizer: visualizer
    });
    $0750269de72ea89d$var$colorSortedBars({
        bars: bars,
        indexes: secondRange
    });
};
const $0750269de72ea89d$export$b620ba1e5e879738 = async ({ bars: bars , visualizer: visualizer  })=>{
    const numberOfBars = bars.length;
    for(let currentIndex = 0; currentIndex < numberOfBars; currentIndex++){
        let minIndex = currentIndex;
        $0750269de72ea89d$var$colorSelectBars({
            bars: bars,
            indexes: [
                currentIndex
            ]
        });
        // Find the shortest bar in the unsorted array
        for(let unsortedIndex = currentIndex + 1; unsortedIndex < numberOfBars; unsortedIndex++)if (bars[unsortedIndex].height < bars[minIndex].height) {
            if (minIndex != currentIndex) $0750269de72ea89d$var$deColorSelectBars({
                bars: bars,
                indexes: [
                    minIndex
                ]
            });
            minIndex = unsortedIndex;
            $0750269de72ea89d$var$colorSelectBars({
                bars: bars,
                indexes: [
                    minIndex
                ]
            });
            await $0750269de72ea89d$var$delay({
                timeout: visualizer.sortDelay
            });
        }
        $0750269de72ea89d$var$deColorSelectBars({
            bars: bars,
            indexes: [
                currentIndex,
                minIndex
            ]
        });
        await $0750269de72ea89d$var$switchBars({
            bars: bars,
            i: currentIndex,
            j: minIndex,
            visualizer: visualizer
        });
        $0750269de72ea89d$var$colorSortedBars({
            bars: bars,
            indexes: [
                currentIndex
            ]
        });
    }
};
const $0750269de72ea89d$var$colorSwapBars = ({ bars: bars , indexes: indexes  })=>{
    indexes.forEach((index)=>bars[index].domElement.classList.add("swapped"));
};
const $0750269de72ea89d$var$deColorSwapBars = ({ bars: bars , indexes: indexes  })=>{
    indexes.forEach((index)=>bars[index].domElement.classList.remove("swapped"));
};
const $0750269de72ea89d$var$switchBars = async ({ bars: bars , i: i , j: j , visualizer: visualizer  })=>{
    $0750269de72ea89d$var$colorSwapBars({
        bars: bars,
        indexes: [
            i,
            j
        ]
    });
    const tempOrder = bars[i].domElement.style.order;
    bars[i].domElement.style.order = bars[j].domElement.style.order;
    bars[j].domElement.style.order = tempOrder;
    // TODO: one way to delay for animations
    await $0750269de72ea89d$var$delay({
        timeout: visualizer.sortDelay
    });
    const temp = bars[i];
    bars[i] = bars[j];
    bars[j] = temp;
    $0750269de72ea89d$var$deColorSwapBars({
        bars: bars,
        indexes: [
            i,
            j
        ]
    });
};


const $ad2bcec7a0192558$var$BUBBLE_SORT_NAME = "bubbleSort";
const $ad2bcec7a0192558$var$MERGE_SORT_NAME = "mergeSort";
const $ad2bcec7a0192558$var$QUICK_SORT_NAME = "quickSort";
const $ad2bcec7a0192558$var$SELECTION_SORT_NAME = "selectionSort";
let $ad2bcec7a0192558$var$visualizer = null;
const $ad2bcec7a0192558$var$visualizerDomElement = document.getElementById("visualizer");
const $ad2bcec7a0192558$var$generateNewBarsButton = document.getElementById("generate-bars");
const $ad2bcec7a0192558$var$resetBarsButton = document.getElementById("reset-bars");
const $ad2bcec7a0192558$var$darkModeToggle = document.getElementById("dark-mode");
const $ad2bcec7a0192558$var$slider = document.getElementById("sort-speed");
const $ad2bcec7a0192558$var$speedDescription = document.getElementById("sort-speed-description");
const $ad2bcec7a0192558$var$debounce = (callback, delay = 300)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>callback.apply(args), delay);
    };
};
const $ad2bcec7a0192558$var$hasBars = ()=>{
    if ($ad2bcec7a0192558$var$visualizer) return $ad2bcec7a0192558$var$visualizer.hasBars();
    console.log("Visualizer is null");
    return false;
};
const $ad2bcec7a0192558$var$isSorted = ()=>{
    if ($ad2bcec7a0192558$var$visualizer) return $ad2bcec7a0192558$var$visualizer.isSorted();
    console.log("Visualizer is null");
    return false;
};
// Generating and resetting bars
const $ad2bcec7a0192558$var$generateBars = ()=>{
    if ($ad2bcec7a0192558$var$visualizer) {
        const numberOfBars = $ad2bcec7a0192558$var$visualizer.generateBars();
        $ad2bcec7a0192558$var$writeMetric({
            metric: numberOfBars,
            metricClassName: "total-bars",
            metricTitle: "Total Bars"
        });
    } else alert("Visualizer is null");
};
const $ad2bcec7a0192558$var$generateNewBars = ()=>{
    if (!$ad2bcec7a0192558$var$isSorted()) {
        $ad2bcec7a0192558$var$generateBars();
        $ad2bcec7a0192558$var$setSortingCapability({
            allowSorting: true
        });
    } else console.log("Sorted!");
};
const $ad2bcec7a0192558$var$resetBars = ()=>{
    if ($ad2bcec7a0192558$var$isSorted()) {
        $ad2bcec7a0192558$var$resetVisualizerBars();
        $ad2bcec7a0192558$var$setSortingCapability({
            allowSorting: true
        });
    } else console.log("Already reset");
};
const $ad2bcec7a0192558$var$resetVisualizerBars = ()=>{
    if ($ad2bcec7a0192558$var$visualizer) $ad2bcec7a0192558$var$visualizer.resetBars();
    else alert("Visualizer is null");
};
/////////////////////////////////////
const $ad2bcec7a0192558$var$enableResetButton = ()=>{
    $ad2bcec7a0192558$var$resetBarsButton.removeAttribute("disabled");
};
// Running the sorts
const $ad2bcec7a0192558$var$getAlgorithm = ({ algorithmName: algorithmName  })=>{
    switch(algorithmName){
        case $ad2bcec7a0192558$var$BUBBLE_SORT_NAME:
            return 0, $0750269de72ea89d$export$b898cba43580844e;
        case $ad2bcec7a0192558$var$MERGE_SORT_NAME:
            return 0, $0750269de72ea89d$export$9c006f0f3b83dc93;
        case $ad2bcec7a0192558$var$QUICK_SORT_NAME:
            return 0, $0750269de72ea89d$export$866270269b9544a5;
        case $ad2bcec7a0192558$var$SELECTION_SORT_NAME:
            return 0, $0750269de72ea89d$export$b620ba1e5e879738;
        default:
            return null;
    }
};
const $ad2bcec7a0192558$var$runSort = ({ algorithmName: algorithmName  })=>{
    const algorithm = $ad2bcec7a0192558$var$getAlgorithm({
        algorithmName: algorithmName
    });
    if ($ad2bcec7a0192558$var$visualizer && algorithm) {
        $ad2bcec7a0192558$var$visualizer.sort({
            algorithm: algorithm,
            callback: $ad2bcec7a0192558$var$enableResetButton
        });
        $ad2bcec7a0192558$var$setSortingCapability({
            allowSorting: false
        });
    } else console.log("We've had a problem :/");
};
///////////////////////////////////////////////////
// Front end viewing options
const $ad2bcec7a0192558$var$setMaxBars = ()=>{
    const width = window.innerWidth;
    const maxBars = Math.floor(width / 3);
    if ($ad2bcec7a0192558$var$visualizer) {
        $ad2bcec7a0192558$var$visualizer.setMaxBars({
            maxBars: maxBars
        });
        $ad2bcec7a0192558$var$writeMetric({
            metric: width,
            metricClassName: "window-width",
            metricTitle: "Width"
        });
        $ad2bcec7a0192558$var$writeMetric({
            metric: maxBars,
            metricClassName: "max-bars",
            metricTitle: "Max Bars"
        });
    } else alert("Visualizer is null");
};
const $ad2bcec7a0192558$var$setVisualizer = ()=>{
    const visualizerContainerQuery = document.getElementsByClassName("visualizer-container");
    $ad2bcec7a0192558$var$visualizer = new (0, $f68696a8a25b0664$export$2e2bcd8739ae039)({
        visualizerContainerQuery: visualizerContainerQuery
    });
    $ad2bcec7a0192558$var$setMaxBars();
    return $ad2bcec7a0192558$var$visualizer;
};
const $ad2bcec7a0192558$var$getSpeedLevelFromValue = ({ value: value  })=>{
    if (value < 1200) return "Slowest";
    else if (value < 1400) return "Slower";
    else if (value < 1600) return "Normal";
    else if (value < 1800) return "Faster";
    else return "Fastest";
};
const $ad2bcec7a0192558$var$setSpeedDescription = (range, speedDescription)=>{
    const value = parseInt(range.value);
    speedDescription.innerHTML = $ad2bcec7a0192558$var$getSpeedLevelFromValue({
        value: value
    });
};
const $ad2bcec7a0192558$var$setSortDelay = (e)=>{
    console.log("slide value", e.target.value);
    const value = parseInt(e.target.value);
    if (!isNaN(value) && $ad2bcec7a0192558$var$visualizer) {
        const sortDelay = 2000 - value;
        $ad2bcec7a0192558$var$visualizer.setSortDelay({
            sortDelay: sortDelay
        });
    } else alert("Visualizer is null");
};
const $ad2bcec7a0192558$var$setDarkMode = (e)=>{
    if ($ad2bcec7a0192558$var$visualizerDomElement && e.target) {
        if (e.target.checked) $ad2bcec7a0192558$var$visualizerDomElement.classList.remove("light-mode");
        else $ad2bcec7a0192558$var$visualizerDomElement.classList.add("light-mode");
    } else console.log("Visualizer DOM element not found");
};
const $ad2bcec7a0192558$var$setSortingCapability = ({ allowSorting: allowSorting  })=>{
    const sortElementIds = [
        "bubble-sort",
        "merge-sort",
        "quick-sort",
        "selection-sort"
    ];
    const buttons = sortElementIds.map((id)=>document.getElementById(id));
    if (!$ad2bcec7a0192558$var$hasBars()) {
        alert("no bars to sort");
        return;
    }
    if (allowSorting) {
        $ad2bcec7a0192558$var$toggleBarButtons({
            canGenerateBars: true
        });
        buttons.forEach((button)=>button && button.removeAttribute("disabled"));
    } else {
        $ad2bcec7a0192558$var$toggleBarButtons({
            canGenerateBars: false
        });
        buttons.forEach((button)=>button && button.setAttribute("disabled", "disabled"));
        $ad2bcec7a0192558$var$resetBarsButton?.setAttribute("disabled", "disabled");
    }
};
const $ad2bcec7a0192558$var$toggleBarButtons = ({ canGenerateBars: canGenerateBars  })=>{
    if (canGenerateBars) {
        $ad2bcec7a0192558$var$resetBarsButton?.setAttribute("hidden", "true");
        $ad2bcec7a0192558$var$generateNewBarsButton?.removeAttribute("hidden");
    } else {
        $ad2bcec7a0192558$var$generateNewBarsButton?.setAttribute("hidden", "true");
        $ad2bcec7a0192558$var$resetBarsButton?.removeAttribute("hidden");
    }
};
//////////////////////////////////////////////////////////////
// Writes the metrics to the screen
const $ad2bcec7a0192558$var$writeMetric = ({ metric: metric , metricClassName: metricClassName , metricTitle: metricTitle  })=>{
    if (metric) {
        const query = document.getElementsByClassName(metricClassName);
        if (query.length > 0) {
            const element = query[0];
            element.innerHTML = `${metricTitle}: ${metric}`;
        }
    } else alert(`${metricTitle} is null`);
};
//////////////////////////////////////////////////////////////
// Attach functions to the DOM 
document.addEventListener("DOMContentLoaded", ()=>{
    $ad2bcec7a0192558$var$visualizer = $ad2bcec7a0192558$var$setVisualizer();
    $ad2bcec7a0192558$var$generateBars();
    $ad2bcec7a0192558$var$setSortingCapability({
        allowSorting: true
    });
});
$ad2bcec7a0192558$var$generateNewBarsButton?.addEventListener("click", ()=>$ad2bcec7a0192558$var$generateNewBars());
$ad2bcec7a0192558$var$resetBarsButton?.addEventListener("click", ()=>$ad2bcec7a0192558$var$resetBars());
$ad2bcec7a0192558$var$darkModeToggle?.addEventListener("click", (e)=>$ad2bcec7a0192558$var$setDarkMode(e));
$ad2bcec7a0192558$var$slider.addEventListener("mouseup", (e)=>$ad2bcec7a0192558$var$setSortDelay(e));
$ad2bcec7a0192558$var$slider.addEventListener("touchend", (e)=>$ad2bcec7a0192558$var$setSortDelay(e));
document.getElementById("bubble-sort")?.addEventListener("click", ()=>$ad2bcec7a0192558$var$runSort({
        algorithmName: $ad2bcec7a0192558$var$BUBBLE_SORT_NAME
    }));
document.getElementById("merge-sort")?.addEventListener("click", ()=>$ad2bcec7a0192558$var$runSort({
        algorithmName: $ad2bcec7a0192558$var$MERGE_SORT_NAME
    }));
document.getElementById("quick-sort")?.addEventListener("click", ()=>$ad2bcec7a0192558$var$runSort({
        algorithmName: $ad2bcec7a0192558$var$QUICK_SORT_NAME
    }));
document.getElementById("selection-sort")?.addEventListener("click", ()=>$ad2bcec7a0192558$var$runSort({
        algorithmName: $ad2bcec7a0192558$var$SELECTION_SORT_NAME
    }));
document.getElementById("sort-speed")?.addEventListener("input", ()=>$ad2bcec7a0192558$var$setSpeedDescription($ad2bcec7a0192558$var$slider, $ad2bcec7a0192558$var$speedDescription));
// Set the max number of bars based on the screen width
window.addEventListener("resize", // TODO: Look into this error
$ad2bcec7a0192558$var$debounce($ad2bcec7a0192558$var$setMaxBars, 250));


//# sourceMappingURL=index.225691e3.js.map
